import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions } from './DashboardsAndMonitoringFormOptions';

export const getDashboardsAndMonitoringFormData = (target, helpWith) => {
  let namespace: string;
  const subject = `Dashboard : ${helpWith} - {formId}`;

  switch (helpWith) {
    case helpWithOptions.wellnessDashboard:
    case helpWithOptions.usageReporting:
      namespace = 'hpe_greenlake_user';
      break;
    case helpWithOptions.sustainabilityDashboard:
      namespace = 'hpe_sustainability_dashboard';
      break;
    default:
      namespace = 'hpe_greenlake_user';
  }

  return getSortedFormFields(target, namespace, subject);
};
